import { connect } from 'react-redux'
import LegacyBranchesDialog from './LegacyBranchesDialog'
import * as actions from '../../redux/branches'

const mapStateToProps = (state) => ({
  branches: state.branches.branches
})

export default connect(mapStateToProps, actions)(LegacyBranchesDialog)
